import { FilePlus2, ArrowRight, Search } from "lucide-react";
import { useState } from "react";
import { Pill } from "../components/Pill";
import { stageLabel } from "../components/Stages";
import type { Job } from "../lib/api";
import { listNote, type ListStatus } from "../components/States";
import { TableScroll } from "../components/TableScroll";

export function Dashboard({
  jobs, status = "ready", query, onOpen, onStart,
}: { jobs: Job[]; status?: ListStatus; query: string; onOpen: (j: Job) => void; onStart: () => void }) {
  const [local, setQ] = useState("");
  const q = query || local;
  const count = (...s: string[]) => jobs.filter((j) => s.includes(j.status)).length;
  const shown = jobs.filter(
    (j) => !q || j.tag.toLowerCase().includes(q.toLowerCase()) || j.id.toLowerCase().includes(q.toLowerCase()),
  );

  return (
    <div className="page">
      <div className="welcome">
        <h2>Welcome back</h2>
        <p>Overview of obsolescence work across the pilot packages.</p>
      </div>

      <div className="eyebrow">Quick actions</div>
      <div className="quick">
        <div className="ic"><FilePlus2 size={24} /></div>
        <div className="grow">
          <h4>Start a new extraction</h4>
          <p>Enter an equipment tag to locate its source documents and recover the installed identity.</p>
        </div>
        <button onClick={onStart}>
          <span className="row">Start <ArrowRight size={16} /></span>
        </button>
      </div>

      <div className="tiles" style={{ marginBottom: 32 }}>
        <div className="card tile"><div className="l">Total jobs</div><div className="n">{jobs.length}</div></div>
        <div className="card tile"><div className="l">Processing</div>
          <div className="n">{count("parsing", "extracting")}</div></div>
        <div className="card tile highlight"><div className="l">Awaiting human review</div>
          <div className="n">{count("awaiting_review", "awaiting_confirmation")}</div></div>
        <div className="card tile good"><div className="l">Completed</div>
          <div className="n">{count("completed")}</div></div>
      </div>

      <h3 style={{ fontSize: 20, marginBottom: 14 }}>Job summary</h3>
      <div className="searchbox" style={{ maxWidth: 460 }}>
        <Search />
        <input value={local} onChange={(e) => setQ(e.target.value)} placeholder="Search by Job ID or tag..." />
      </div>
      <section className="card" style={{ padding: 0, overflow: "hidden" }}>
        <TableScroll label="Job summary">
        <table>
          <thead><tr><th>Job ID</th><th>Tag</th><th>Package</th><th>Stage</th><th>Status</th><th /></tr></thead>
          <tbody>
            {(() => {
              const note = listNote(status, shown.length, jobs.length ? "No job matches." : "No jobs yet.", "Loading jobs");
              return note && <tr><td colSpan={6} className="muted">{note}</td></tr>;
            })()}
            {shown.map((j) => (
              <tr key={j.id}>
                <td className="mono">J-{j.id.slice(0, 4).toUpperCase()}</td>
                <td className="mono" style={{ color: "var(--color-primary)" }}>{j.tag}</td>
                <td>{j.package}</td>
                <td>{stageLabel(j.stage)}</td>
                <td><Pill value={j.status} /></td>
                <td><button className="ghost" onClick={() => onOpen(j)}>Open</button></td>
              </tr>
            ))}
          </tbody>
        </table>
        </TableScroll>
      </section>
    </div>
  );
}
